<template>
  <div>
    <div class="p-md m-b-md">
      <div class="app-block p-md">
        <h3 class="heading-line title is-4 has-text-weight-light">
          <span
            :class="'school-title-'+school"
          >Frais de dossier</span>
        </h3>

        <div
          v-if="application.promoCodes && application.promoCodes.length"
          class="m-b-sm"
        >
          <promo-code-display
            :promo="application.promoCodes[0]"
            :has-fees="!!(application.fees && Object.keys(application.fees).length > 0)"
          />
        </div>

        <div v-if="application.payment_mode === 'BANK-CHECK'">
          <h3 class="title is-5 has-text-weight-light">
            Vous avez choisi le règlement de vos frais de dossier par
            chèque
          </h3>
          <hr>
          <div class="has-text-centered">
            <div>
              <div>
                <span>Veuillez adresser votre chèque de {{ schoolFees }} {{ schoolCurrency }} accompagné du
                  <a
                    :href="'/candidature/bordereau/' + application.id"
                    title="Bordereau de remise de chèque"
                  >bordereau</a>
                  à l'adresse suivante :</span>
              </div>
              <div class="p-md">
                <a
                  :href="'/candidature/bordereau/' + application.id"
                  title="Bordereau de remise de chèque"
                ><i
                  class="fa fa-file-pdf-o fa-3x"
                  aria-hidden="true"
                /></a>
              </div>
              <br>
              <strong>Siège social Diderot Education</strong>
              <br>Service National des Inscriptions
              <br>8 rue Hautefeuille
              <br>75006 Paris
              <br>France
            </div>
            <div
              v-if="candidate.visa_request === true"
              class="p-t-lg"
            >
              <h4 class="has-text-weight-bold">
                Adresse de retour du chèque en cas de refus de visa
              </h4>
              {{ application.payment_return_address }}
            </div>
          </div>
        </div>

        <div v-if="application.payment_mode === 'BANK-TRANSFER'">
          <h3 class="title is-4 has-text-weight-light">
            Vous avez choisi le règlement de vos frais de dossier par
            virement
          </h3>
          <hr>
          <div class="has-text-centered">
            <div>
              <div>
                Veuillez vous rapprocher de votre banque et effectuer un virement bancaire de {{ schoolFees }}
                {{ schoolCurrency }}, vers
                le compte suivant :
              </div>
              <div class="p-md">
                <a
                  href="/docs/RIB-DiderotEducation.pdf"
                  target="_blank"
                ><i
                  class="fa fa-file-pdf-o fa-3x"
                  aria-hidden="true"
                /></a>
              </div>
              <div>Merci d'indiquer lors de votre virement la dénomination suivante :</div>
              <strong>{{ candidate.first_name }} {{ candidate.last_name }} - {{
                application.choices[0].training_name
              }} - {{
                application.choices[0].campus_name
              }}</strong>
            </div>
          </div>
        </div>

        <div v-if="application.payment_mode === 'BANK-NOTE'">
          <h3 class="title is-4 has-text-weight-light">
            Vous avez choisi le règlement de vos frais de dossier en
            espèces
          </h3>
          <hr>
          <div class="has-text-centered">
            <div>
              <div>
                <p>
                  Veuillez vous rendre sur le campus de votre choix pour régler les frais de dossier
                  de {{ schoolFees }} {{ schoolCurrency }}
                </p>
                <p>
                  Un reçu vous sera remis et une confirmation de pré-inscription sera envoyée par mail
                  et
                  déposée sur Diderot Max
                </p>
              </div>
            </div>
          </div>
        </div>

        <div v-if="application.payment_mode === 'CB'">
          <div class="has-text-left">
            <div class="app-block  p-md">
              <h3 class="title is-4 has-text-weight-light">
                Frais de dossier réglés par carte bancaire
              </h3>
              <table class="">
                <thead>
                  <tr />
                  <tr />
                </thead>
                <tbody>
                  <tr>
                    <td><strong>Référence de l'opération:</strong></td>
                    <td>{{ application.fees.reference }}</td>
                  </tr>
                  <tr>
                    <td><strong>Montant:</strong></td>
                    <td>{{ application.fees.montant }} euros</td>
                  </tr>
                  <tr>
                    <td><strong>Date:</strong></td>
                    <td>{{ application.fees.date }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>


        <div
          v-if="!application.fees"
          class="has-text-right"
        >
          <button
            v-if="!application.fees"
            class="button"
            @click="edit"
          >
            Modifier
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import services from 'services/candidate'
import {mapGetters} from 'vuex'
import PromoCodeDisplay from "../../../components/application/PromoCodeDisplay.vue";
import feesMixin from "../../../mixins/feesMixin";

export default {
  components: {PromoCodeDisplay},
  mixins: [feesMixin],
  props: {
    school: {type: String},
    candidate: {type: Object},
    application: {type: Object},
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      schoolChoice: 'organization/getSchoolBySlug'
    }),
    schoolCurrency() {
      if (this.school) {
        const school = this.schoolChoice(this.school)
        return school ? school.fees_currency : ''
      }
    },
    /*schoolFees() {
      if (this.school) {
        const school = this.schoolChoice(this.school)
        return school ? school.application_fees : ''
      }
    }*/
  },
  methods: {
    // ne fonctionne pas sous firefox
    fetchCheckStub() {
      services.fetchCheckStub(this.application.id)
          .then((response) => {
            let headers = response.headers;
            let blob = new Blob([response.data], {type: headers['content-type']});
            // IE doesn't allow using a blob object directly as link href
            // instead it is necessary to use msSaveOrOpenBlob
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(blob);
              return;
            }
            let link = document.createElement('a');
            let header = response.headers['content-disposition'];
            let filename = header.match(/filename="(.+)"/)[1];
            const data = window.URL.createObjectURL(blob);
            link.href = data;
            link.download = filename;
            link.click();
            setTimeout(function () {
              // For Firefox it is necessary to delay revoking the ObjectURL
              window.URL.revokeObjectURL(data)
                  , 100
            })
          }).catch((err) => {
        this.error = err
      })
    },

    edit: function () {
      this.$emit('edit')
    }
  }
}
</script>
